export const getAuthDialogDisplay = (state) => state.ui.authDialog.display;
export const getAuthDialogInterval = (state) => state.ui.authDialog.interval;
export const getBlacklistImportDialog = (state) => state.ui.blacklist.importDialog.show;
export const getContactListListName = (state) => state.ui.contactList.title.name;